module.exports = "/images/right-arrow.svg?767d598993cf425112a3fe5cb5515de9";